<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-datepicker v-model="filter.startDate" :md-immediately="true">
          <label>Từ ngày</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-datepicker v-model="filter.endDate" :md-immediately="true">
          <label>Đến ngày</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-field>
          <label>Hình thức thanh toán</label>
          <md-select v-model="filter.paymentMethod">
            <md-option value="Chuyển khoản">Chuyển khoản</md-option>
            <md-option value="Thu tiền mặt">Thu tiền mặt</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20 md-xsamll-size-50">
        <md-button class="md-success md-sm" @click="exportExcel">
          Xuất excel
        </md-button>
        <md-tooltip>
          {{
            filter.paymentMethod === "Chuyển khoản"
              ? "Phiếu thu Chuyển khoản"
              : "Phiếu thu tiền mặt"
          }}
        </md-tooltip>
      </div>
    </div>
    <md-table
      :value="queriedData"
      class="table-hover table-border"
      table-header-color="green"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="ID" class="table-cell" align="left" md-numeric>
          {{ item.orderId }}
        </md-table-cell>
        <md-table-cell md-label="Ngày tạo" class="table-cell" align="left">
          {{ formatDate(new Date(item.orderDate)).substring(0, 11) }}
        </md-table-cell>
        <md-table-cell
          md-label="Tổng tiền"
          class="table-cell"
          align="left"
          md-numeric
        >
          {{ formatMoney(item.amount * -1) }}
        </md-table-cell>
        <md-table-cell md-label="Mã đại lý" class="table-cell" align="left">
          {{ item.customerCode }}
        </md-table-cell>
        <md-table-cell md-label="Đại lý" class="table-cell" align="left">
          {{ item.customerName }}
        </md-table-cell>
        <md-table-cell md-label="Nhân viên" class="table-cell" align="left">
          {{ item.salerName }}
        </md-table-cell>
        <md-table-cell md-label="Mã nhân viên" class="table-cell" align="left">
          {{ item.salerCode }}
        </md-table-cell>
        <md-table-cell md-label="Phương thức" class="table-cell" align="left">
          {{ item.paymentMethod }}
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div style="display: flex; justify-content: flex-end">
      <div class="">
        <p class="card-category">
          Hiển thị từ {{ from + 1 }} tới {{ to }} trong số {{ total }} mục
        </p>
      </div>
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </pagination>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
export default {
  components: {
    Pagination,
  },
  props: ["db", "customerSelected", "isReload", "paymentHistory"],
  data() {
    return {
      listPay: [],
      filter: {
        paymentMethod: "Chuyển khoản",
        startDate: null,
        endDate: null,
        salerCode: -1,
        isPayment: -1,
        status: -1,
      },
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },
  methods: {
    async exportExcel() {
      const tHeader = Object.values(
        this.filter.paymentMethod === "Thu tiền mặt"
          ? this.AllFieldDataCashReceipts
          : this.AllFieldDataBankReceipts
      );
      const filterVal = Object.keys(
        this.filter.paymentMethod === "Thu tiền mặt"
          ? this.AllFieldDataCashReceipts
          : this.AllFieldDataBankReceipts
      );
      this.$exportExcel(tHeader, filterVal, this.loadDataToExport);
      this.$messageSuccess(
        this.filter.paymentMethod === "Thu tiền mặt"
          ? "Xuất phiếu thu tiền mặt"
          : "Xuất phiếu thu chuyển khoản"
      );
    },
  },
  computed: {
    loadDataToExport() {
      let list = [];
      this.filter.paymentMethod === "Thu tiền mặt"
        ? this.dataFilter.forEach((item) => {
            list.push({
              hienThiTrenSo: "",
              ngayHachToan: this.formatDate(new Date(item.orderDate)).substring(
                0,
                11
              ),
              ngayChungTu: this.formatDate(new Date(item.orderDate)).substring(
                0,
                11
              ),
              soChungTu: "",
              maDoiTuong: item.customerCode,
              tenDoiTuong: "",
              diaChi: "",
              nopVaoTK: item.accountPayment,
              moTaiNH: "",
              lyDoThu: 34,
              dienGiaiLyDoThu: item.reason,
              nhanVienThu: item.employeeCode,
              loaiTien: "",
              tyGia: "",
              dienGiai: item.reason,
              TKNo: 1121,
              TKCo: 131,
              soTien: item.amount * -1,
              soTienQuyDoi: "",
              doiTuong: item.customerCode,
              khoanMucCP: "",
              donVi: "",
              doiTuongTHCP: "",
              congTrinh: "",
              donDatHang: "",
              hopDongMua: "",
              hopDongBan: "",
              maThongKe: "",
            });
          })
        : this.dataFilter.forEach((item) => {
            list.push({
              hienThiTrenSo: "",
              ngayHachToan: this.formatDate(new Date(item.orderDate)).substring(
                0,
                11
              ),
              ngayChungTu: this.formatDate(new Date(item.orderDate)).substring(
                0,
                11
              ),
              soChungTu: "",
              maDoiTuong: item.customerCode,
              tenDoiTuong: "",
              diaChi: "",
              lyDoNop: 13,
              dienGiaiLyDoNop: item.reason,
              nguoiNop: "",
              nhanVienThu: item.employeeCode,
              kemTheo: "",
              loaiTien: "",
              tyGia: "",
              dienGiai: item.reason,
              TKNo: 1111,
              TKCo: 131,
              soTien: item.amount * -1,
              quyDoi: "",
              doiTuong: item.customerCode,
              TKNganHang: "",
            });
          });
      return list;
    },
    dataFilter() {
      let a = this.paymentHistory;
      if (this.filter.startDate !== null) {
        a = a.filter(
          (item) => item.orderDate >= this.filter.startDate.valueOf()
        );
      }
      if (this.filter.endDate !== null) {
        a = a.filter((item) => item.orderDate <= this.filter.endDate.valueOf());
      }
      if (this.filter.salerCode !== -1) {
        a = a.filter((item) => item.salerCode === this.filter.salerCode);
      }
      if (this.filter.paymentMethod !== -1) {
        a = a.filter(
          (item) => item.paymentMethod === this.filter.paymentMethod
        );
      }
      return a;
    },
    queriedData() {
      return this.dataFilter.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.dataFilter.length;
    },
  },
  // watch: {
  //   filterState() {
  //     let query = this.db
  //       .collection(process.env.VUE_APP_ORDER)
  //       .where("customerCode", "==", this.customerSelected.data.customerId)
  //     if (this.filter.salerCode !== -1) {
  //       query = query.where("salerCode", "==", this.filter.salerCode);
  //     }
  //     if (this.filter.orderDay) {
  //       query = query
  //         .where("orderDay",
  //           "==",
  //           this.formatDate(this.filter.orderDay).substring(0, 11)
  //         );
  //     }
  //     if (this.filter.isPayment !== -1) {
  //       query = query
  //         .where("isPayment", "==", this.filter.isPayment);
  //     }
  //     if (this.filter.status !== -1) {
  //       query = query.where("status", "==", this.filter.status);
  //     }
  //     this.$store.dispatch("FLAG_LOADING", true);
  //     this.listPay = [];
  //     query.get().then(doc => {
  //       doc.forEach(item => {
  //         this.listPay.push({
  //           id: item.id,
  //           data: item.data()
  //         })
  //       })
  //       this.$store.dispatch("FLAG_LOADING", false);
  //     })
  //     .catch(error => {
  //       this.$messageError("Có lỗi! Thử tải lại trang")
  //       console.log(error);
  //       this.$store.dispatch("FLAG_LOADING", false);
  //     })
  //   }
  // }
};
</script>
<style scoped>
.itemPayHistory {
  border: none;
  display: flex;
  justify-content: space-around;
}
.itemPayHistory > p {
  width: 17%;
}
.itemPayHistory:hover {
  background: rgba(95, 158, 160, 0.171);
}
.itemOrderHistory {
  background-color: rgba(179, 199, 124, 0.336);
}

.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
</style>
